import React from "react";
import { pipLink } from "common/routing";
import { Account, SubmissionType } from "../../generated/graphql";
import { FlexColumn, FlexRow } from "../Common/__styles__/Layout";
import { AccountLogo } from "../Common/AccountLogo";
import { Body, Title } from "../Common/Typography";
import { ObjectInfoPanelLink } from "./__styles__/Submission";
import { VisibilityPill } from "./VisibilityPill";

type SubmissionHeaderProps = {
  account: Pick<Account, "logoUrl" | "name">;
  objectDisplay?: string;
  objectInfoPanelLink?: ReturnType<typeof pipLink>;
  submissionType: Pick<SubmissionType, "name">;
  viewers: Array<string>;
};

const SubmissionHeader: React.FC<SubmissionHeaderProps> = ({
  account,
  objectDisplay,
  objectInfoPanelLink,
  submissionType,
  children,
  viewers,
}) => {
  const objectLink =
    objectDisplay && objectInfoPanelLink ?
      <ObjectInfoPanelLink to={objectInfoPanelLink} target="_blank">
        {objectDisplay}
      </ObjectInfoPanelLink>
    : null;
  return (
    <FlexRow>
      <FlexColumn>
        {account.logoUrl && (
          <AccountLogo
            account={account}
            displayPrintOnly={true}
            style={{ marginRight: "16px" }}
          />
        )}
      </FlexColumn>
      <FlexColumn gap="m">
        <FlexColumn gap="s">
          <Title size="small" type="semiBold" color="contentPrimary">
            {submissionType.name}
          </Title>
          {objectLink && (
            <Body size="default" type="link">
              {objectLink}
            </Body>
          )}
          {children}
        </FlexColumn>
        <VisibilityPill viewers={viewers} />
      </FlexColumn>
    </FlexRow>
  );
};

export default SubmissionHeader;
